class PressList extends HTMLElement {
  constructor() {
    super();

    if (!document.querySelector('.press-set')) return;

    this.pressGrid = this.querySelector('.press-grid');
    this.pressSet = [...document.querySelectorAll('script.press-set')]
      .map((elem) => {
        return JSON.parse(elem.textContent);
      })
      .flat();
    this.generateHTML();
  }

  generateHTML() {
    if (!this.pressSet.length) return;
    const pressSet = this.pressSet;

    for (var x = 0; x < pressSet.length; x++) {
      const item = pressSet[x];

      const grid = document.createElement('div');
      grid.classList.add('grid__item');
      grid.classList.add('grid__press-item');

      const link = document.createElement('a');
      link.classList.add('press-item__link');
      link.href = item.link_url;
      link.title = item.title;
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');

      const linkInner = document.createElement('span');
      linkInner.classList.add('visually-hidden');
      linkInner.textContent = item.title;
      link.appendChild(linkInner);

      const imageWrapper = document.createElement('div');
      imageWrapper.classList.add('press-item__image');

      const image = document.createElement('img');
      image.src = item.image;
      image.width = 280;
      image.height = 373;
      image.alt = item.image_alt ? item.image_alt : item.title;
      image.setAttribute('loading', 'lazy');
      image.classList.add('motion-reduce');
      imageWrapper.appendChild(image);

      grid.appendChild(imageWrapper);
      grid.appendChild(link);

      this.pressGrid.appendChild(grid);
    }
  }
}

customElements.define('press-list', PressList);
